export default __webpack_public_path__ + "static/media/nomi.baffd177.png";